<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Editar Composto">
      <b-container fluid class="mt-4 mb-3">
        <b-form>
          <div class="inputs-group px-3 py-3 mb-5">
            <h3 class="mb-4">Dados do Composto</h3>
            <b-row>
              <b-col>
                <b-form-group
                  label="Número do Composto"
                  label-for="compound_number"
                >
                  <b-form-input
                    id="compound_number"
                    type="text"
                    v-model="form.compound_number"
                    aria-describedby="input-1-live-feedback"
                    :state="validateState('compound_number')"
                    required
                    disabled
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Data de Chegada" label-for="arrived_date">
                  <b-form-input
                    id="datepicker"
                    type="date"
                    style="
                      border: 1px solid black;
                      background-color: transparent;
                      outline: none;
                      box-shadow: none;
                      color: black;
                    "
                    v-model="form.arrived_date"
                    aria-describedby="input-2-live-feedback"
                    :state="validateState('arrived_date')"
                    required
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="input-2-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Tipo de Cogumelo" label-for="product_id">
                  <b-form-select
                    v-model="product_id"
                    id="mushroom"
                    :options="products"
                    value-field="id"
                    text-field="type"
                    aria-describedby="input-3-live-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Peso Inicial(Em kg)"
                  label-for="quantity_arrived"
                >
                  <b-form-input
                    id="quantity_arrived"
                    v-model="form.quantity_arrived"
                    autocomplete="off"
                    aria-describedby="input-4-live-feedback"
                    :state="validateState('quantity_arrived')"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback
                  id="input-4-live-feedback"
                  style="font-weight: bold"
                >
                  Campo obrigatório
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Nota Fiscal">
                  <b-form-file
                    v-model="newInvoice"
                    plain
                    accept=".pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Mais Detalhes" label-for="moreDetails">
                  <b-form-textarea
                    id="moreDetails"
                    v-model="form.more_details"
                    autocomplete="off"
                    placeholder="Escreva aqui..."
                    rows="3"
                    no-resize
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <b-alert v-model="showAlert" variant="danger" dismissible>
            {{ message }}
          </b-alert>
          <b-row class="justify-content-end px-3 py-3 mb-3">
            <b-col cols="auto">
              <b-row>
                <b-col class="col-6">
                  <b-button
                    type="button"
                    variant="danger"
                    @click="openModal(false)"
                  >
                    Cancelar
                  </b-button>
                </b-col>
                <b-col class="col-6">
                  <b-button
                    type="button"
                    variant="success"
                    @click="openModal(true)"
                  >
                    Editar
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <ModalCompound
        :isConfirm="isConfirm"
        @responseModalCompound="addCompound($event)"
      />
      <ModalExit @responseModalLeaveView="confirmLeaveView()" />
    </Dashboard>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalCompound from '../components/compound/ModalCompound.vue';
import Dashboard from '../components/Dashboard.vue';
import HeaderVue from '../components/Header.vue';
import ModalExit from '../components/client/ModalExit.vue';
import Sidebar from '../components/Sidebar.vue';
import MixinModalCompound from '../utils/MixinModalCompound';
import { Products } from '../services/Products';
import { Compound, EditCompound } from '../services/Compound';
import showError from '../utils/showError';

export default {
  components: { HeaderVue, Sidebar, Dashboard, ModalCompound, ModalExit },
  mixins: [MixinModalCompound, validationMixin],
  data() {
    return {
      form: {
        id: null,
        product: null,
        compound_number: null,
        arrived_date: null,
        quantity_produced: null,
        quantity_arrived: null,
        more_details: null,
        is_discarded: false,
        invoice: null,
      },
      product_id: '',
      newInvoice: null,
      products: [],
      showAlert: false,
      message: '',
    };
  },
  validations: {
    form: {
      compound_number: {
        required,
      },
      arrived_date: {
        required,
      },
      quantity_arrived: {
        required,
      },
    },
  },
  created() {
    Products()
      .then((res) => {
        this.products = res.data;
      })
      .catch(showError);

    Compound(this.$route.params.compostoId)
      .then((res) => {
        this.form = res.data;
        this.product_id = this.form.product.id;
        this.form.arrived_date = this.form.arrived_date.slice(0, 10);
      })
      .catch(showError);
  },
  methods: {
    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    async addCompound(event) {
      if (event) {
        this.$v.form.$touch();
        if (this.$v.$anyError) {
          this.$bvModal.hide('modal-compound');
          this.message = 'Verifique seus dados e tente novamente.';
          this.showAlert = true;
          return;
        }
        const formData = new FormData();

        formData.append('id', this.form.id);
        formData.append('product_id', this.product_id);
        formData.append('compound_number', this.form.compound_number);
        formData.append('arrived_date', this.form.arrived_date);
        formData.append('invoice', this.newInvoice);
        formData.append('quantity_produced', this.form.quantity_produced);
        formData.append('quantity_arrived', this.form.quantity_arrived);
        formData.append('more_details', this.form.more_details);
        formData.append('is_discarded', this.form.is_discarded);

        await EditCompound(this.form.id, formData)
          .then(() => {
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              this.leaveView = true;
              this.toBackCompoundView();
            }, 1000);
          })
          .catch(showError);
        return;
      }
      this.leaveView = true;
      this.toBackCompoundView();
    },
  },
};
</script>

<style scoped>
form,
h3 {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #121212;
}
.inputs-group {
  background: rgba(217, 217, 217, 0.54);
  border-radius: 20px;
}

input:focus,
#moreDetails,
select#mushroom.custom-select,
#quantity_arrived,
#compound_number {
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}

h3 {
  font-size: 25px;
  line-height: 30px;
}

span {
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}

label {
  font-size: 20px;
  line-height: 24px;
}

button {
  border: none;
  padding: 8px 40px 8px 40px;
  border-radius: 24px;
  color: white;
  font-weight: 400;
  font-size: 18px;
}

button:focus {
  outline: none;
}
</style>
